import { app } from '../../app.module'
app
  // サブカテゴリ管理モーダルを表示するためのボタン
  .directive('editSubCategoryButton', () => {
    return {
      restrict: 'E',
      template: require('./edit-sub-category-button.pug')(),
      scope: {
        categoryName: '@categoryName',
        subCategoryName: '@subCategoryName',
        sortNo: '@sortNo',
      },
      controller: function ($rootScope, $scope, $mdDialog, $attrs) {
        // ボタン表示判定用にタイプをセット
        $scope.type = $attrs.type

        // ボタンをクリックした際の処理
        $scope.showSubCategoryModal = function () {
          // モーダル用のスコープを新規に作成し、モーダル内で使用するパラメーターを格納
          const modalScope: {
            type: string
            categoryName: string
            subCategoryName: string
            sortNo: number
          } = $rootScope.$new()

          modalScope.type = $attrs.type
          modalScope.categoryName = $scope.categoryName
          modalScope.subCategoryName = $scope.subCategoryName
          modalScope.sortNo = $scope.sortNo !== undefined ? parseInt($scope.sortNo, 10) : null

          // モーダルを表示する
          $mdDialog.show({
            template: require('./edit-sub-category-modal.pug')(),
            scope: modalScope,
            clickOutsideToClose: true,
          })
        }
      },
    }
  })
